import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import WebsolutionsSidebar from '../../../components/WebsolutionsSidebar'
import BranddevelopmentSidebar from '../../../components/BranddevelopmentSidebar'
import DigitalmarketingSidebar from '../../../components/DigitalmarketingSidebar'

import Fill from '../../../images/Fill.svg'
import Divider from '../../../images/Divider.svg'

export const query = graphql`
  query emailmarketing {
    embanner: imageSharp(id: {regex: "/images/Thor.jpg/"}) {
      sizes(quality: 75, maxWidth: 1000, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}, toFormat: PNG) {tracedSVG src}
    },
}
`

const EmailMarketing = ({data:{embanner}}) => (
  <section>
    <article className='container'>
    <div className='full-Width' style={{alignItems:'flex-start'}}>
      <div className='half-Width-75 paddingRight mobBottommargin'>
        <div style={{display:'block'}}>
          <h1 className='smallerHone'>Email Marketing</h1>
          <img src={Divider} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/>
          <p className='smallerHone'><span className='gradient'>Case studies such as these inspire and motivate us.</span></p>
          <p>See how businesses similar to yours are growing with Digital Marketing.</p>
          <div style={{backgroundImage:`url("${embanner.sizes.src}"), url("${embanner.sizes.tracedSVG}")`, backgroundPosition:'center', backgroundSize:'cover', minHeight:'50vh', marginBottom:'1.45rem'}}>
          </div>
          <p>A personalized, segmented and targeted email marketing campaign is important for brand awareness and drive conversions.
          It provides an effective connection with your targeted audience and helps you reach out to your current and potential customers keeping them updated on your brand’s latest deals and news.</p>
          <p style={{marginBottom:'0'}}>Our expertise uses effective tools, strategy, implementation and result tracking in order to achieve the best possible brand engagement, template design, tracking and reporting.</p>
        </div>
      </div>
      <div className='half-Width-25 service-sidebar'>
        <div style={{marginBottom:'2.5rem'}}><DigitalmarketingSidebar /></div>
        <div style={{marginBottom:'2.5rem'}}><WebsolutionsSidebar /></div>
        <div><BranddevelopmentSidebar /></div>
      </div>
    </div>
    </article>
  </section>
)

export default EmailMarketing



// WEBPACK FOOTER //
// ./src/pages/services/digital-marketing/email-marketing.js